import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { URL_AUTH_SIGNIN, URL_AUTH_TOKEN_REFRESH } from '@envs/base-urls';
import { AuthService } from '@core/server/auth.service';
import { EMPTY } from 'rxjs';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  if( req.url === URL_AUTH_SIGNIN ) next( req );
  
  const authSvc: AuthService = inject( AuthService );
  
  const { userAccessToken } = authSvc.getToken();
  
  if( !userAccessToken ) return next(req);

  if ( req.url === URL_AUTH_TOKEN_REFRESH ) {
		const requestClone = authSvc.addToken( req );
		return next( requestClone );
	}

  if ( authSvc.isRefreshing() ) return EMPTY;

  const clonedRequest = authSvc.addToken( req );
  return next( clonedRequest );
};
